import cookie from "../cookie";

var delayparams = '&wbp2u=UID|0|PHONE|0|wap'

if(cookie.get('uidal')){
    delayparams = delayparams.replace('UID',cookie.get('uidal')!.substring(0,16))
}else{
    delayparams = delayparams.replace('UID','')
}

if(cookie.get('mtp') !== null){
    if(cookie.get('mtp') == '0'){
        delayparams = delayparams.replace('PHONE','3')
    }else{
        delayparams = delayparams.replace('PHONE',cookie.get('mtp')!)
    }
}else{
    delayparams = delayparams.replace('PHONE','0')
}

export default delayparams